import React from 'react'

const RegisterPage: React.FC = () => {
  return (
    <div>
      <h1>Register</h1>
      {/* Add your register form component here */}
    </div>
  )
}

export default RegisterPage
